(function () {
  'use strict';

  var ROOT_ID = 'uncomfy-builder';

  var TAB_ORDER = ['beginning', 'friend', 'fur', 'accessories', 'room', 'summary'];

  var ACC_MAX = 4;

  var ACC_MIN = 1;

  var PATH_PRICING = { keychain: 'tier', desk: 'tier', sticker: 'flat', fun: 'none' };

  var DEFAULT_SWATCH_SHAPE = 'heart';
  var SWATCH_SHAPES = {
    heart: {
      viewBox: '0 0 32 29',
      path:
        'M16 27 C14.8 23.6 4 17.4 4 10.4 C4 6.3 7.1 3.4 10.8 3.4 ' +
        'C13.2 3.4 15.1 4.8 16 6.6 C16.9 4.8 18.8 3.4 21.2 3.4 ' +
        'C24.9 3.4 28 6.3 28 10.4 C28 17.4 17.2 23.6 16 27 Z'
    },
    circle: {
      viewBox: '0 0 32 32',
      path: 'M16 2 A14 14 0 1 0 16 30 A14 14 0 1 0 16 2 Z'
    },
    square: {
      viewBox: '0 0 32 32',
      path:
        'M7 2 H25 A5 5 0 0 1 30 7 V25 A5 5 0 0 1 25 30 ' +
        'H7 A5 5 0 0 1 2 25 V7 A5 5 0 0 1 7 2 Z'
    },
    scallop: {
      viewBox: '0 0 32 32',
      path:
        'M27 16 A4.6 4.6 0 0 1 23.78 23.78 A4.6 4.6 0 0 1 16 27 ' +
        'A4.6 4.6 0 0 1 8.22 23.78 A4.6 4.6 0 0 1 5 16 ' +
        'A4.6 4.6 0 0 1 8.22 8.22 A4.6 4.6 0 0 1 16 5 ' +
        'A4.6 4.6 0 0 1 23.78 8.22 A4.6 4.6 0 0 1 27 16 Z'
    }
  };

  var SVG_NS = 'http://www.w3.org/2000/svg';

  var state = { path: null, friend: null, fur: null, accessories: [], room: {}, name: '', locked: false };

  var currentFriends = [];
  var currentFur = [];
  var currentAccessories = [];
  var currentAccessoryCategories = [];
  var currentRoom = [];
  var currentRoomCategories = [];
  var currentCartVariants = [];
  var preloadedFurUrls = {};

  var frontispieceTemplate = null;
  var currentScene = null;
  var currentSceneKey = null;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function collectCatalogs() {
    var nodes = document.querySelectorAll(
      'script[type="application/json"][data-uncomfy-catalog]'
    );
    var catalogs = {};

    nodes.forEach(function (node) {
      var name = node.getAttribute('data-uncomfy-catalog');
      if (!name) return;
      try {
        var parsed = JSON.parse(node.textContent);
        catalogs[name] = Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        console.error('[uncomfy-builder] failed to parse catalog "' + name + '"', err);
        catalogs[name] = [];
      }
    });

    return catalogs;
  }

  function getRoot() {
    return document.getElementById(ROOT_ID);
  }

  function collectCartVariants(path) {
    if (!path) return [];
    var node = document.querySelector(
      'script[type="application/json"][data-uw-cart-variants="' + path + '"]'
    );
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.error('[uncomfy-builder] failed to parse the cart variant list', err);
      return [];
    }
  }

  function glyphNode() {
    var root = getRoot();
    if (!root) return null;
    var tpl = root.querySelector('template[data-uw-glyph-template]');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    return tpl.content.firstElementChild.cloneNode(true);
  }

  function setBadge(card, selected) {
    var existing = card.querySelector('.uw-select-badge');
    if (!selected) {
      if (existing) card.removeChild(existing);
      return;
    }
    if (existing) return;
    var glyph = glyphNode();
    if (!glyph) return;
    var badge = document.createElement('span');
    badge.className = 'uw-select-badge';
    badge.appendChild(glyph);
    card.appendChild(badge);
  }

  function numberSteps() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-tab]').forEach(function (tab) {
      var num = tab.querySelector('.uw-step__num');
      if (!num) return;
      var index = TAB_ORDER.indexOf(tab.getAttribute('data-uw-tab'));
      num.textContent = index >= 0 ? String(index + 1) : '';
    });
  }

  function isPathAvailable(card) {
    return !!card && !card.classList.contains('is-unavailable');
  }

  function markPathSelected(path) {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-path]').forEach(function (card) {
      var selected = card.getAttribute('data-uw-path') === path;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      setBadge(card, selected);
    });
  }

  function selectPath(path) {
    if (state.locked) return;
    if (!PATH_PRICING[path]) return;
    state.path = path;
    currentCartVariants = collectCartVariants(path);
    markPathSelected(path);
    refreshTabs();
    refreshPrice();
    refreshTurnPage();
    refreshPostcardViews();
  }

  function autoSelectSinglePath() {
    var root = getRoot();
    if (!root || state.path || state.locked) return;
    var available = [];
    root.querySelectorAll('[data-uw-path]').forEach(function (card) {
      if (isPathAvailable(card)) available.push(card);
    });
    if (available.length !== 1) return;
    selectPath(available[0].getAttribute('data-uw-path'));
  }

  function isTabEnabled(name) {
    if (name === 'beginning') return true;
    if (name === 'friend') return !!state.path;
    if (name === 'fur') return !!state.friend;
    if (name === 'accessories') return !!state.fur;
    return !!state.fur && state.accessories.length >= ACC_MIN;
  }

  function refreshTabs() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-tab]').forEach(function (tab) {
      var enabled = isTabEnabled(tab.getAttribute('data-uw-tab')) && !state.locked;
      tab.classList.toggle('is-frozen', state.locked);
      tab.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (!enabled) tab.tabIndex = -1;
      if (!state.locked) {
        tab.classList.toggle('is-locked', !isTabEnabled(tab.getAttribute('data-uw-tab')));
      }
    });
  }

  function ensureValidActiveTab() {
    var root = getRoot();
    if (!root) return;
    var active = root.querySelector('[data-uw-tab].is-active');
    var name = active ? active.getAttribute('data-uw-tab') : null;
    if (name && isTabEnabled(name)) return;

    var target = TAB_ORDER[0];
    for (var i = 0; i < TAB_ORDER.length; i++) {
      if (isTabEnabled(TAB_ORDER[i])) target = TAB_ORDER[i];
    }
    activateTab(target);
  }

  function nextEnabledStep() {
    var root = getRoot();
    if (!root) return null;
    var active = root.querySelector('[data-uw-tab].is-active');
    var name = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
    var start = TAB_ORDER.indexOf(name);
    for (var i = start + 1; i < TAB_ORDER.length; i++) {
      if (isTabEnabled(TAB_ORDER[i])) return TAB_ORDER[i];
    }
    return null;
  }

  var SCROLLERS = '[data-uw-path-grid], [data-uw-friend-grid], [data-uw-fur-grid], [data-uw-acc-grid], [data-uw-room-grid]';
  var SCROLL_CUE_SLACK = 4;
  var scrollCuePending = false;
  var scrollCueObserver = null;
  var scrollCueResizeObserver = null;

  function measureScrollCues() {
    scrollCuePending = false;
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-panel]').forEach(function (panel) {
      var box = panel.querySelector(SCROLLERS);
      var overflow = box ? box.scrollHeight - box.clientHeight : 0;
      panel.classList.toggle(
        'is-scrollable',
        overflow > SCROLL_CUE_SLACK && box.scrollTop < overflow - SCROLL_CUE_SLACK
      );
    });
  }

  function syncScrollCues() {
    if (scrollCuePending) return;
    scrollCuePending = true;
    requestAnimationFrame(measureScrollCues);
  }

  function watchScrollCues() {
    var root = getRoot();
    if (!root) return;

    if (scrollCueObserver) scrollCueObserver.disconnect();
    scrollCueObserver = new MutationObserver(syncScrollCues);
    root.querySelectorAll(SCROLLERS).forEach(function (box) {
      scrollCueObserver.observe(box, { childList: true, subtree: true });
    });

    if (scrollCueResizeObserver) scrollCueResizeObserver.disconnect();
    if ('ResizeObserver' in window) {
      scrollCueResizeObserver = new ResizeObserver(syncScrollCues);
      root.querySelectorAll(SCROLLERS).forEach(function (box) {
        scrollCueResizeObserver.observe(box);
      });
    }

    var panels = root.querySelector('.uw-builder__panels');
    if (panels) panels.addEventListener('scroll', syncScrollCues, { capture: true, passive: true });

    syncScrollCues();
  }

  function activateTab(name) {
    var root = getRoot();
    if (!root) return;
    if (!isTabEnabled(name)) return;

    if (TAB_ORDER.indexOf(name) >= 2) scheduleLoadingArtPreload();

    if (name === 'accessories') scheduleAccessoryLayerPreload();

    var previous = root.querySelector('[data-uw-tab].is-active');
    var changed = !previous || previous.getAttribute('data-uw-tab') !== name;

    var tabs = root.querySelectorAll('[data-uw-tab]');
    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-uw-tab') === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    var panels = root.querySelectorAll('[data-uw-panel]');
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-uw-panel') !== name;
    });

    refreshPrice();
    refreshTurnPage();
    refreshBackButton();
    refreshGuestbookLink();
    syncPreviewForStep(name);
    syncScrollCues();
    if (changed) scrollBuilderIntoView();
  }

  function scrollBuilderIntoView() {
    var root = getRoot();
    if (!root) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    root.scrollIntoView({
      block: 'start',
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function goToStep(name) {
    var root = getRoot();
    if (state.locked) return;
    if (!root || !isTabEnabled(name)) return;
    var active = root.querySelector('[data-uw-tab].is-active');
    var current = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
    if (name !== 'beginning' && TAB_ORDER.indexOf(name) < TAB_ORDER.indexOf(current)) {
      resetStepsAfter(name);
    }
    activateTab(name);
    renderPreview();
  }

  function resetStepsAfter(name) {
    var idx = TAB_ORDER.indexOf(name);
    for (var i = idx + 1; i < TAB_ORDER.length; i++) {
      var s = TAB_ORDER[i];
      if (s === 'fur') state.fur = null;
      else if (s === 'accessories') state.accessories = [];
      else if (s === 'room') state.room = {};
    }
    renderFurGrid();
    renderAccGrid();
    renderAccHint();
    renderRoomGrid();
    refreshTabs();
    refreshPrice();
  }

  function pricingMode() {
    return PATH_PRICING[state.path] || 'none';
  }

  function variantForPath() {
    var mode = pricingMode();
    if (mode === 'none') return null;
    if (mode === 'flat') return currentCartVariants[0] || null;
    return findVariantForCount(state.accessories.length);
  }

  function currentPriceText() {
    if (pricingMode() === 'tier' && !state.fur) return null;
    var match = variantForPath();
    return match && match.price ? match.price : null;
  }

  function refreshPrice() {
    var root = getRoot();
    if (!root) return;
    var pill = root.querySelector('[data-uw-price]');
    if (!pill) return;
    var price = currentPriceText();
    pill.textContent = price || pill.getAttribute('data-uw-price-placeholder') || '';

    var active = root.querySelector('[data-uw-tab].is-active');
    var step = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
    if (step === 'summary') {
      pill.hidden = postcardView !== 'details' || state.locked || pricingMode() === 'none';
    } else {
      pill.hidden = pricingMode() === 'none';
    }
  }

  function refreshBackButton() {
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('[data-uw-back-page]');
    if (!btn) return;
    var active = root.querySelector('[data-uw-tab].is-active');
    var name = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
    btn.hidden = state.locked;
    btn.disabled = TAB_ORDER.indexOf(name) <= 0;
  }

  function syncPreviewForStep(name) {
    var root = getRoot();
    if (!root) return;
    var charPreview = root.querySelector('[data-uw-preview]');
    var roomStage = root.querySelector('[data-uw-room-stage]');
    var postcard = root.querySelector('[data-uw-postcard]');
    var isRoom = name === 'room';
    var isPostcard = name === 'summary';
    if (charPreview) charPreview.hidden = isRoom || isPostcard;
    if (roomStage) roomStage.hidden = !isRoom;
    if (postcard) postcard.hidden = !isPostcard;
    var book = root.querySelector('.uw-book');
    if (book) book.classList.toggle('is-postcard', isPostcard);
    if (isRoom) renderRoomScene();
    if (isPostcard) {
      renderPostcard();
      warmKeepsake();
    }
  }

  function refreshTurnPage() {
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('[data-uw-turn-page]');
    if (!btn) return;
    var active = root.querySelector('[data-uw-tab].is-active');
    var name = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
    var show;
    if (name === 'beginning') show = !!state.path;
    else if (name === 'friend') show = !!state.friend;
    else if (name === 'fur') show = !!state.fur;
    else if (name === 'accessories') show = state.accessories.length >= ACC_MIN;
    else show = true;
    btn.hidden = name === 'summary';
    btn.disabled = !show || state.locked;

    refreshForwardAction(name);
  }

  function refreshForwardAction(step) {
    var root = getRoot();
    if (!root) return;
    var onPostcard = step === 'summary';
    var forward = null;
    if (onPostcard && state.locked) {
      forward = '[data-uw-checkout]';
    } else if (onPostcard && pricingMode() === 'none') {
      forward = '[data-uw-download]';
    } else if (onPostcard && postcardView === 'details') {
      forward = '[data-uw-buy]';
    } else if (onPostcard) {
      forward = '[data-uw-show-details]';
    }
    ['[data-uw-show-details]', '[data-uw-buy]', '[data-uw-download]', '[data-uw-checkout]']
      .forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) el.hidden = sel !== forward;
      });
  }

  function buildFriendCard(friend) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'uw-friend-card';
    card.setAttribute('data-uw-friend-name', friend.name);
    card.setAttribute('aria-pressed', 'false');

    var thumb = document.createElement('span');
    thumb.className = 'uw-friend-card__thumb';
    if (friend.thumbnail) {
      var img = document.createElement('img');
      img.className = 'uw-friend-card__img';
      img.src = friend.thumbnail;
      img.alt = friend.name;
      img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'uw-friend-card__ph';
      ph.textContent = friend.name;
      thumb.appendChild(ph);
    }
    card.appendChild(thumb);

    var label = document.createElement('span');
    label.className = 'uw-friend-card__name';
    label.textContent = friend.name;
    card.appendChild(label);

    return card;
  }

  function renderFriendGrid(friends) {
    var root = getRoot();
    if (!root) return;
    var grid = root.querySelector('[data-uw-friend-grid]');
    if (!grid) return;

    grid.textContent = '';

    if (!friends.length) {
      var empty = document.createElement('p');
      empty.className = 'uw-builder__soon';
      empty.textContent = 'No friends yet — add a Friend block to get started.';
      grid.appendChild(empty);
      return;
    }

    var frag = document.createDocumentFragment();
    friends.forEach(function (friend) {
      frag.appendChild(buildFriendCard(friend));
    });
    grid.appendChild(frag);

    if (state.friend) {
      markSelected(state.friend.name);
    }
  }

  function markSelected(name) {
    var root = getRoot();
    if (!root) return;
    var cards = root.querySelectorAll('[data-uw-friend-name]');
    cards.forEach(function (card) {
      var selected = card.getAttribute('data-uw-friend-name') === name;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      setBadge(card, selected);
    });
  }

  function selectFriend(name) {
    var friend = null;
    for (var i = 0; i < currentFriends.length; i++) {
      if (currentFriends[i].name === name) { friend = currentFriends[i]; break; }
    }
    if (!friend) return;

    var changed = !state.friend || state.friend.name !== friend.name;
    state.friend = friend;
    if (changed) {
      state.fur = null;
      renderFurGrid();
    }
    markSelected(name);
    refreshTabs();
    ensureValidActiveTab();
    refreshTurnPage();
    refreshPrice();
    renderPreview();

    var furs = furForFriend();
    var warm = function () { preloadFurBodies(furs); };
    if (window.requestIdleCallback) window.requestIdleCallback(warm); else setTimeout(warm, 0);
  }

  function preloadFurBodies(furs) {
    furs.forEach(function (f) {
      [f.body, f.body_ears].forEach(function (url) {
        if (url && !preloadedFurUrls[url]) {
          preloadedFurUrls[url] = true;
          var img = new Image();
          img.decoding = 'async';
          img.src = url;
        }
      });
    });
  }

  var preloadedAccLayerUrls = {};
  var accLayerPreloadRequested = false;
  var ACC_PRELOAD_WINDOW = 4;

  function preloadAccessoryLayers() {
    if (accLayerPreloadRequested) return;
    accLayerPreloadRequested = true;

    var queue = [];
    currentAccessories.forEach(function (a) {
      var url = a && a.layer;
      if (url && !preloadedAccLayerUrls[url]) {
        preloadedAccLayerUrls[url] = true;
        queue.push(url);
      }
    });

    var next = 0;
    function pump() {
      if (next >= queue.length) return;
      var img = new Image();
      img.decoding = 'async';
      if ('fetchPriority' in img) img.fetchPriority = 'low';
      img.onload = pump;
      img.onerror = pump;
      img.src = queue[next++];
    }
    for (var i = 0; i < ACC_PRELOAD_WINDOW; i++) pump();
  }

  function scheduleAccessoryLayerPreload() {
    if (accLayerPreloadRequested) return;
    var warm = function () { preloadAccessoryLayers(); };
    if (window.requestIdleCallback) window.requestIdleCallback(warm);
    else window.setTimeout(warm, 500);
  }

  function furForFriend() {
    if (!state.friend) return [];
    var target = String(state.friend.name).trim().toLowerCase();
    return currentFur.filter(function (f) {
      return f && typeof f.friend === 'string' &&
        f.friend.trim().toLowerCase() === target;
    });
  }

  function buildFurSwatch(url, index) {
    var root = getRoot();
    var shapeName = (root && root.getAttribute('data-uw-swatch-shape')) || DEFAULT_SWATCH_SHAPE;
    var shape = SWATCH_SHAPES[shapeName] || SWATCH_SHAPES[DEFAULT_SWATCH_SHAPE];

    var vb = shape.viewBox.split(' ');
    var vbWidth = vb[2];
    var vbHeight = vb[3];

    var clipId = 'uw-swatch-' + index;
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'uw-fur-swatch');
    svg.setAttribute('viewBox', shape.viewBox);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    var defs = document.createElementNS(SVG_NS, 'defs');
    var clip = document.createElementNS(SVG_NS, 'clipPath');
    clip.setAttribute('id', clipId);
    var clipPath = document.createElementNS(SVG_NS, 'path');
    clipPath.setAttribute('d', shape.path);
    clip.appendChild(clipPath);
    defs.appendChild(clip);
    svg.appendChild(defs);

    var image = document.createElementNS(SVG_NS, 'image');
    image.setAttribute('href', url);
    image.setAttribute('x', '0');
    image.setAttribute('y', '0');
    image.setAttribute('width', vbWidth);
    image.setAttribute('height', vbHeight);
    image.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    image.setAttribute('clip-path', 'url(#' + clipId + ')');
    svg.appendChild(image);

    var edge = document.createElementNS(SVG_NS, 'path');
    edge.setAttribute('d', shape.path);
    edge.setAttribute('class', 'uw-fur-swatch__edge');
    svg.appendChild(edge);

    return svg;
  }

  function buildFurCard(fur, index) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'uw-fur-card';
    card.setAttribute('data-uw-fur-name', fur.fur);
    card.setAttribute('aria-pressed', 'false');

    var thumb = document.createElement('span');
    thumb.className = 'uw-fur-card__thumb';
    if (fur.swatch) {
      thumb.appendChild(buildFurSwatch(fur.swatch, index));
    } else {
      var ph = document.createElement('span');
      ph.className = 'uw-fur-card__ph';
      ph.textContent = fur.fur;
      thumb.appendChild(ph);
    }
    card.appendChild(thumb);

    var label = document.createElement('span');
    label.className = 'uw-fur-card__name';
    label.textContent = fur.fur;
    card.appendChild(label);

    return card;
  }

  function renderFurGrid() {
    var root = getRoot();
    if (!root) return;
    var grid = root.querySelector('[data-uw-fur-grid]');
    if (!grid) return;

    grid.textContent = '';

    if (!state.friend) {
      grid.appendChild(soonMessage('Pick a friend first ✿'));
      return;
    }

    var furs = furForFriend();
    if (!furs.length) {
      grid.appendChild(soonMessage('No fur colours for ' + state.friend.name + ' yet.'));
      return;
    }

    var frag = document.createDocumentFragment();
    furs.forEach(function (fur, i) {
      frag.appendChild(buildFurCard(fur, i));
    });
    grid.appendChild(frag);

    if (state.fur) {
      markFurSelected(state.fur.fur);
    }
  }

  function markFurSelected(name) {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-fur-name]').forEach(function (card) {
      var selected = card.getAttribute('data-uw-fur-name') === name;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      setBadge(card, selected);
    });
  }

  function selectFur(name) {
    var furs = furForFriend();
    var fur = null;
    for (var i = 0; i < furs.length; i++) {
      if (furs[i].fur === name) { fur = furs[i]; break; }
    }
    if (!fur) return;

    state.fur = fur;
    markFurSelected(name);
    refreshTabs();
    refreshTurnPage();
    refreshPrice();
    renderPreview();
  }

  function isAccSelected(name) {
    return state.accessories.some(function (a) { return a.name === name; });
  }

  function buildAccCard(acc) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'uw-acc-card';
    card.setAttribute('data-uw-acc-name', acc.name);
    card.setAttribute('aria-pressed', 'false');

    var baseName = acc.base_name || acc.name;

    var thumb = document.createElement('span');
    thumb.className = 'uw-acc-card__thumb';
    if (acc.thumbnail) {
      var img = document.createElement('img');
      img.className = 'uw-acc-card__img';
      img.src = acc.thumbnail;
      img.alt = acc.name;
      img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'uw-acc-card__ph';
      ph.textContent = baseName;
      thumb.appendChild(ph);
    }
    card.appendChild(thumb);

    var labelWrap = document.createElement('span');
    labelWrap.className = 'uw-acc-card__label';
    var nameLine = document.createElement('span');
    nameLine.className = 'uw-acc-card__name';
    nameLine.textContent = baseName;
    labelWrap.appendChild(nameLine);
    if (acc.color) {
      var colorLine = document.createElement('span');
      colorLine.className = 'uw-acc-card__color';
      colorLine.textContent = acc.color;
      labelWrap.appendChild(colorLine);
    }
    card.appendChild(labelWrap);

    return card;
  }

  function renderAccGrid() {
    var root = getRoot();
    if (!root) return;
    var grid = root.querySelector('[data-uw-acc-grid]');
    if (!grid) return;

    grid.textContent = '';

    if (!currentAccessories.length) {
      grid.appendChild(soonMessage('No accessories yet.'));
      return;
    }

    function accGroup(name, items) {
      var group = document.createElement('div');
      group.className = 'uw-acc-group';
      if (name) {
        var label = document.createElement('p');
        label.className = 'uw-acc-group__label';
        label.textContent = name;
        group.appendChild(label);
      }
      var options = document.createElement('div');
      options.className = 'uw-acc-group__options';
      items.forEach(function (item) { options.appendChild(buildAccCard(item)); });
      group.appendChild(options);
      return group;
    }

    var frag = document.createDocumentFragment();
    var placed = {};

    currentAccessoryCategories.forEach(function (category) {
      var items = currentAccessories.filter(function (a) { return a.category === category.name; });
      if (!items.length) return;
      items.forEach(function (a) { placed[a.name] = true; });
      frag.appendChild(accGroup(category.name, items));
    });

    var orphans = currentAccessories.filter(function (a) { return !placed[a.name]; });
    if (orphans.length) {
      frag.appendChild(accGroup('', orphans));
    }

    grid.appendChild(frag);

    markAccSelected();
  }

  function markAccSelected() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-acc-name]').forEach(function (card) {
      var selected = isAccSelected(card.getAttribute('data-uw-acc-name'));
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      setBadge(card, selected);
    });
  }

  function resolveCap(str) {
    return String(str == null ? '' : str)
      .split('[cap]').join(ACC_MAX)
      .split('[min]').join(ACC_MIN);
  }

  function renderAccHint(message) {
    var root = getRoot();
    if (!root) return;
    var el = root.querySelector('[data-uw-acc-hint]');
    if (!el) return;
    if (message) { el.textContent = message; return; }
    el.textContent = resolveCap(el.getAttribute('data-uw-acc-default'));
  }

  function accCapMessage() {
    var root = getRoot();
    var el = root ? root.querySelector('[data-uw-acc-hint]') : null;
    var tpl = (el && el.getAttribute('data-uw-acc-cap')) || "you've picked [cap]! unpick one to add something new";
    return resolveCap(tpl);
  }

  function conflictsWith(a, b) {
    var ra = a && a.regions ? a.regions : [];
    var rb = b && b.regions ? b.regions : [];
    if (!ra.length || !rb.length) return false;
    for (var i = 0; i < ra.length; i++) {
      if (rb.indexOf(ra[i]) !== -1) return true;
    }
    return false;
  }

  function toggleAccessory(name) {
    var acc = null;
    for (var i = 0; i < currentAccessories.length; i++) {
      if (currentAccessories[i].name === name) { acc = currentAccessories[i]; break; }
    }
    if (!acc) return;

    var idx = -1;
    for (var j = 0; j < state.accessories.length; j++) {
      if (state.accessories[j].name === name) { idx = j; break; }
    }

    if (idx >= 0) {
      state.accessories.splice(idx, 1);
    } else {
      state.accessories = state.accessories.filter(function (a) {
        return !conflictsWith(a, acc);
      });
      if (state.accessories.length >= ACC_MAX) {
        renderAccHint(accCapMessage());
        markAccSelected();
        renderPreview();
        return;
      }
      state.accessories.push(acc);
    }

    markAccSelected();
    renderAccHint();
    refreshPrice();
    refreshTabs();
    refreshTurnPage();
    renderPreview();
  }

  function soonMessage(text) {
    var p = document.createElement('p');
    p.className = 'uw-builder__soon';
    p.textContent = text;
    return p;
  }

  function categoryZ(name) {
    for (var i = 0; i < currentRoomCategories.length; i++) {
      if (currentRoomCategories[i].name === name) return Number(currentRoomCategories[i].z);
    }
    return 0;
  }

  function buildRoomCard(item) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'uw-acc-card';
    card.setAttribute('data-uw-room-name', item.name);
    card.setAttribute('aria-pressed', 'false');

    var thumb = document.createElement('span');
    thumb.className = 'uw-acc-card__thumb';
    if (item.thumbnail) {
      var img = document.createElement('img');
      img.className = 'uw-acc-card__img';
      img.src = item.thumbnail;
      img.alt = item.name;
      img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'uw-acc-card__ph';
      ph.textContent = item.name;
      thumb.appendChild(ph);
    }
    card.appendChild(thumb);

    var label = document.createElement('span');
    label.className = 'uw-acc-card__label';
    var nameLine = document.createElement('span');
    nameLine.className = 'uw-acc-card__name';
    nameLine.textContent = item.name;
    label.appendChild(nameLine);
    card.appendChild(label);

    return card;
  }

  function renderRoomGrid() {
    var root = getRoot();
    if (!root) return;
    var grid = root.querySelector('[data-uw-room-grid]');
    if (!grid) return;

    grid.textContent = '';

    if (!currentRoom.length) {
      grid.appendChild(soonMessage('No room items yet.'));
      return;
    }

    var frag = document.createDocumentFragment();
    currentRoomCategories.forEach(function (category) {
      var items = currentRoom.filter(function (i) { return i.category === category.name; });
      if (!items.length) return;

      var group = document.createElement('div');
      group.className = 'uw-room-group';

      var label = document.createElement('p');
      label.className = 'uw-room-group__label';
      label.textContent = category.name;
      group.appendChild(label);

      var options = document.createElement('div');
      options.className = 'uw-room-group__options';
      items.forEach(function (item) { options.appendChild(buildRoomCard(item)); });
      group.appendChild(options);

      frag.appendChild(group);
    });
    grid.appendChild(frag);

    markRoomSelected();
  }

  function markRoomSelected() {
    var root = getRoot();
    if (!root) return;
    root.querySelectorAll('[data-uw-room-name]').forEach(function (card) {
      var name = card.getAttribute('data-uw-room-name');
      var selected = false;
      for (var key in state.room) {
        if (state.room[key] && state.room[key].name === name) { selected = true; break; }
      }
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function selectRoomOption(name) {
    var item = null;
    for (var i = 0; i < currentRoom.length; i++) {
      if (currentRoom[i].name === name) { item = currentRoom[i]; break; }
    }
    if (!item) return;

    var current = state.room[item.category];
    if (current && current.name === item.name) {
      delete state.room[item.category];
    } else {
      state.room[item.category] = item;
    }

    markRoomSelected();
    renderRoomScene();
  }

  function paintRoomScene(layersEl, charEl) {
    if (!layersEl || !charEl) return;

    layersEl.textContent = '';
    charEl.textContent = '';

    roomLayers().forEach(function (l) { layersEl.appendChild(makeLayer(l.url)); });

    characterLayerUrls().forEach(function (u) { charEl.appendChild(makeLayer(u)); });
  }

  function renderRoomScene() {
    var root = getRoot();
    if (!root) return;
    paintRoomScene(
      root.querySelector('[data-uw-room-layers]'),
      root.querySelector('[data-uw-room-character]')
    );
  }

  var ROOM_FLOOR_OVERLAY_Z = 1.5;

  var ROOM_FLOOR_Z = 2;

  function roomFloorOverlayLayer() {
    var root = getRoot();
    var stage = root ? root.querySelector('[data-uw-room-stage]') : null;
    if (!stage) return null;
    var url = stage.getAttribute('data-uw-room-floor-overlay');
    if (!url) return null;
    return {
      label: 'floor overlay',
      url: url,
      exportUrl: stage.getAttribute('data-uw-room-floor-overlay-export') || url,
      w: stage.getAttribute('data-uw-room-floor-overlay-w'),
      h: stage.getAttribute('data-uw-room-floor-overlay-h'),
      z: ROOM_FLOOR_OVERLAY_Z
    };
  }

  function roomLayers() {
    var layers = [];
    for (var key in state.room) {
      var pick = state.room[key];
      if (!pick || !pick.layer) continue;
      layers.push({
        label: pick.category + ' · ' + pick.name,
        url: pick.layer,
        exportUrl: pick.layer_export,
        w: pick.layer_w,
        h: pick.layer_h,
        z: categoryZ(pick.category)
      });
    }
    var hasPickedFloor = layers.some(function (l) { return l.z === ROOM_FLOOR_Z; });
    if (!hasPickedFloor) {
      var overlay = roomFloorOverlayLayer();
      if (overlay) layers.push(overlay);
    }
    return layers.sort(function (a, b) { return a.z - b.z; });
  }

  var POSTCARD_FRAME = {
    windowCenterX: 66.42,
    windowCenterY: 33.75,
    windowWidth: 52.33,
    windowHeight: 51.50,
    windowRotation: 2.8,
    captionRotation: 2.63,
    captionLeft: 39.92,
    captionTop: 60.25,
    captionWidth: 52.25,
    captionHeight: 10.31,
    nudge: 0
  };

  var POSTCARD_WINDOW_BLEED = 2.5;

  var ROOM_HEIGHT_OVER_WIDTH = 4 / 3;

  function postcardNumber(el, attr, fallback) {
    var n = parseFloat(el.getAttribute(attr));
    return isFinite(n) ? n : fallback;
  }

  function postcardCropOffset(card) {
    var frameW = postcardNumber(card, 'data-uw-frame-w', 0);
    var frameH = postcardNumber(card, 'data-uw-frame-h', 0);
    if (!frameW || !frameH) return 0;

    var windowPxW = POSTCARD_FRAME.windowWidth / 100 * frameW;
    var windowPxH = POSTCARD_FRAME.windowHeight / 100 * frameH;
    var visible = Math.min(1, windowPxH / (windowPxW * ROOM_HEIGHT_OVER_WIDTH)) * 100;
    if (visible >= 100) return 0;

    var scale = readStagePercent(card, '--uw-room-char-scale', ROOM_CHAR_SCALE_FALLBACK);
    var floor = readStagePercent(card, '--uw-room-char-floor', ROOM_CHAR_FLOOR_FALLBACK);
    var offset = (floor - scale / 2) - visible / 2 + POSTCARD_FRAME.nudge;
    return Math.min(Math.max(offset, 0), 100 - visible);
  }

  function applyPostcardFrame(card) {
    var win = card.querySelector('[data-uw-postcard-window]');
    if (win) {
      win.style.setProperty('--uw-window-rotate', POSTCARD_FRAME.windowRotation + 'deg');
      win.style.setProperty('--uw-window-cx', POSTCARD_FRAME.windowCenterX + '%');
      win.style.setProperty('--uw-window-cy', POSTCARD_FRAME.windowCenterY + '%');
      win.style.setProperty(
        '--uw-window-width',
        (POSTCARD_FRAME.windowWidth + POSTCARD_WINDOW_BLEED * 2) + '%'
      );
      win.style.setProperty(
        '--uw-window-height',
        (POSTCARD_FRAME.windowHeight + POSTCARD_WINDOW_BLEED * 3 / 4 * 2) + '%'
      );
    }
    var caption = card.querySelector('[data-uw-postcard-caption-box]');
    if (caption) {
      caption.style.setProperty('--uw-caption-rotate', POSTCARD_FRAME.captionRotation + 'deg');
      caption.style.setProperty('--uw-caption-left', POSTCARD_FRAME.captionLeft + '%');
      caption.style.setProperty('--uw-caption-top', POSTCARD_FRAME.captionTop + '%');
      caption.style.setProperty('--uw-caption-width', POSTCARD_FRAME.captionWidth + '%');
      caption.style.setProperty('--uw-caption-height', POSTCARD_FRAME.captionHeight + '%');
    }
  }

  function renderPostcard() {
    var root = getRoot();
    if (!root) return;
    var card = root.querySelector('[data-uw-postcard]');
    if (!card) return;

    applyPostcardFrame(card);

    paintRoomScene(
      root.querySelector('[data-uw-postcard-layers]'),
      root.querySelector('[data-uw-postcard-character]')
    );

    var room = card.querySelector('[data-uw-postcard-room]');
    if (room) room.style.setProperty('--uw-postcard-crop', postcardCropOffset(card) + '%');

    renderPostcardCaption();
  }

  function renderPostcardCaption() {
    var root = getRoot();
    if (!root) return;
    var caption = root.querySelector('[data-uw-postcard-caption]');
    if (!caption) return;
    var name = state.name || '';
    caption.textContent = name;
    caption.style.setProperty('--uw-caption-chars', Math.max(name.length, 1));
  }

  function makeLayer(url) {
    var img = document.createElement('img');
    img.className = 'uw-preview__layer';
    img.src = url;
    img.alt = '';
    return img;
  }

  var REGION_DRAW_ORDER = {
    back: 0, feet: 1, torso: 2, hand: 3, neck: 4, ears: 5, crown: 6, head_top: 7, face: 8
  };

  function regionPriority(acc) {
    var regs = acc && acc.regions ? acc.regions : [];
    var p = 0;
    for (var i = 0; i < regs.length; i++) {
      var v = REGION_DRAW_ORDER[regs[i]];
      if (v > p) p = v;
    }
    return p;
  }

  function characterLayers() {
    if (!state.fur) return [];
    var fur = state.fur;
    var useEars = state.accessories.some(function (a) { return a.triggers_ears_apart; }) &&
      !!fur.body_ears;
    var body = useEars
      ? { label: fur.fur + ' (ears apart)', url: fur.body_ears, exportUrl: fur.body_ears_export, w: fur.body_ears_w, h: fur.body_ears_h }
      : { label: fur.fur, url: fur.body, exportUrl: fur.body_export, w: fur.body_w, h: fur.body_h };
    if (!body.url) return [];
    var layers = [body];
    state.accessories.slice()
      .sort(function (a, b) {
        var dz = Number(a.z) - Number(b.z);
        if (dz !== 0) return dz;
        return regionPriority(a) - regionPriority(b);
      })
      .forEach(function (a) {
        if (a.layer) {
          layers.push({ label: a.name, url: a.layer, exportUrl: a.layer_export, w: a.layer_w, h: a.layer_h });
        }
      });
    return layers;
  }

  function characterLayerUrls() {
    return characterLayers().map(function (layer) { return layer.url; });
  }

  function previewMode() {
    var urls = characterLayerUrls();
    if (urls.length) {
      return { kind: 'body', key: 'body:' + state.friend.name, urls: urls };
    }
    if (state.friend && state.friend.blank) {
      return { kind: 'shell', key: 'shell:' + state.friend.name };
    }
    return { kind: 'frontispiece', key: 'frontispiece' };
  }

  function buildSceneEl(mode) {
    var scene;
    if (mode.kind === 'frontispiece') {
      if (frontispieceTemplate) return frontispieceTemplate.cloneNode(true);
      scene = document.createElement('div');
      scene.className = 'uw-preview__scene uw-frontispiece';
      return scene;
    }
    scene = document.createElement('div');
    scene.className = 'uw-preview__scene';
    if (mode.kind === 'body') {
      mode.urls.forEach(function (u) { scene.appendChild(makeLayer(u)); });
    } else {
      scene.appendChild(makeLayer(state.friend.blank));
    }
    return scene;
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function sparkle(target) {
    document.dispatchEvent(new CustomEvent('uw:sparkle', { detail: { target: target || null } }));
  }

  function sparkleAt(x, y) {
    document.dispatchEvent(new CustomEvent('uw:sparkle', { detail: { x: x, y: y } }));
  }

  function fadeOutAndRemove(el) {
    if (prefersReducedMotion()) {
      if (el.parentNode) el.parentNode.removeChild(el);
      return;
    }
    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', cleanup);
      if (el.parentNode) el.parentNode.removeChild(el);
    }
    el.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, 260);
    el.style.opacity = '0';
  }

  function renderPreview() {
    var root = getRoot();
    if (!root) return;
    var stage = root.querySelector('[data-uw-preview-stage]');
    if (!stage) return;

    if (!frontispieceTemplate) {
      var f = stage.querySelector('[data-uw-frontispiece]');
      if (f) {
        frontispieceTemplate = f.cloneNode(true);
        currentScene = f;
        currentSceneKey = 'frontispiece';
      }
    }

    var mode = previewMode();

    if (mode.key === currentSceneKey && currentScene) {
      if (mode.kind === 'body' || mode.kind === 'shell') {
        var fresh = buildSceneEl(mode);
        while (currentScene.firstChild) currentScene.removeChild(currentScene.firstChild);
        while (fresh.firstChild) currentScene.appendChild(fresh.firstChild);
      }
      return;
    }

    var scene = buildSceneEl(mode);
    scene.classList.add('is-entering');
    stage.appendChild(scene);
    void scene.offsetWidth;
    scene.classList.remove('is-entering');

    var prev = currentScene;
    currentScene = scene;
    currentSceneKey = mode.key;
    if (prev && prev !== scene) fadeOutAndRemove(prev);
  }

  var EXPORT_QUALITY = 0.9;
  var ROOM_CHAR_SCALE_FALLBACK = 31;
  var ROOM_CHAR_FLOOR_FALLBACK = 75;
  var ASPECT_EPSILON = 0.005;
  var CANVAS_AREA_WARN = 16777216;

  function drawContain(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width;
    var ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var scale = Math.min(w / iw, h / ih);
    var dw = iw * scale;
    var dh = ih * scale;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }

  function loadExportImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () {
        reject(new Error('[uncomfy-export] failed to load ' + url));
      };
      img.src = url;
    });
  }

  function loadLayer(rec) {
    return loadExportImage(rec.exportUrl || rec.url).then(function (img) {
      return { rec: rec, img: img };
    });
  }

  function makeExportCanvas(w, h) {
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('[uncomfy-export] could not get a 2d context');
    if (w * h > CANVAS_AREA_WARN) {
      console.warn('[uncomfy-export] canvas is ' + w + '×' + h + ' (' +
        Math.round(w * h / 1e6) + ' Mpx) — past the point some browsers stop rasterizing.');
    }
    return { canvas: canvas, ctx: ctx };
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('[uncomfy-export] toBlob produced nothing for ' + type));
      }, type, quality);
    });
  }

  function auditAspects(label, reference, loaded) {
    if (!loaded.length) return 0;
    var refAspect = reference.naturalWidth / reference.naturalHeight;
    var mismatched = 0;
    var rows = loaded.map(function (l) {
      var aspect = l.img.naturalWidth / l.img.naturalHeight;
      var drift = Math.abs(aspect - refAspect) / refAspect;
      if (drift > ASPECT_EPSILON) mismatched++;
      return {
        layer: l.rec.label,
        native: l.img.naturalWidth + '×' + l.img.naturalHeight,
        aspect: aspect.toFixed(4),
        matches: drift > ASPECT_EPSILON ? 'NO — ' + (drift * 100).toFixed(1) + '% off' : 'yes'
      };
    });
    console.log('[uncomfy-export] ' + label + ' aspect audit — reference ' +
      reference.naturalWidth + '×' + reference.naturalHeight + ' (' + refAspect.toFixed(4) + ')');
    console.table(rows);
    if (mismatched) {
      console.warn('[uncomfy-export] ' + mismatched + ' ' + label + ' layer(s) differ from the ' +
        'reference aspect — they are letterboxed inside the canvas rather than filling it.');
    }
    return mismatched;
  }

  function exportCharacter() {
    var layers = characterLayers();
    if (!layers.length) {
      return Promise.reject(new Error('[uncomfy-export] nothing to export — pick a friend and a fur first'));
    }
    return Promise.all(layers.map(loadLayer)).then(function (loaded) {
      var body = loaded[0];
      var w = Number(body.rec.w) || body.img.naturalWidth;
      var h = Number(body.rec.h) || body.img.naturalHeight;
      var out = makeExportCanvas(w, h);
      loaded.forEach(function (l) { drawContain(out.ctx, l.img, 0, 0, w, h); });
      auditAspects('character', body.img, loaded.slice(1));
      return canvasToBlob(out.canvas, 'image/png').then(function (blob) {
        return { blob: blob, width: w, height: h };
      });
    });
  }

  function readStagePercent(stage, prop, fallback) {
    var n = parseFloat(window.getComputedStyle(stage).getPropertyValue(prop));
    return isFinite(n) ? n : fallback;
  }

  function buildRoomCanvas() {
    var root = getRoot();
    var stage = root ? root.querySelector('[data-uw-room-stage]') : null;
    if (!stage) return Promise.reject(new Error('[uncomfy-export] room stage not found'));

    var baseUrl = stage.getAttribute('data-uw-room-base-export');
    if (!baseUrl) return Promise.reject(new Error('[uncomfy-export] no room base image is set'));

    var charLayers = characterLayers();
    if (!charLayers.length) {
      return Promise.reject(new Error('[uncomfy-export] nothing to export — pick a friend and a fur first'));
    }

    var baseRec = {
      label: 'room base',
      url: baseUrl,
      exportUrl: baseUrl,
      w: stage.getAttribute('data-uw-room-base-w'),
      h: stage.getAttribute('data-uw-room-base-h')
    };
    var roomRecs = roomLayers();

    return Promise.all([
      loadLayer(baseRec),
      Promise.all(roomRecs.map(loadLayer)),
      Promise.all(charLayers.map(loadLayer))
    ]).then(function (results) {
      var base = results[0];
      var roomLoaded = results[1];
      var charLoaded = results[2];

      var w = Number(baseRec.w) || base.img.naturalWidth;
      var h = Number(baseRec.h) || base.img.naturalHeight;
      var out = makeExportCanvas(w, h);

      out.ctx.fillStyle = window.getComputedStyle(stage).backgroundColor;
      out.ctx.fillRect(0, 0, w, h);

      drawContain(out.ctx, base.img, 0, 0, w, h);
      roomLoaded.forEach(function (l) { drawContain(out.ctx, l.img, 0, 0, w, h); });

      var scale = readStagePercent(stage, '--uw-room-char-scale', ROOM_CHAR_SCALE_FALLBACK);
      var floor = readStagePercent(stage, '--uw-room-char-floor', ROOM_CHAR_FLOOR_FALLBACK);
      var side = h * scale / 100;
      var charX = (w - side) / 2;
      var charY = (h * floor / 100) - side;
      charLoaded.forEach(function (l) { drawContain(out.ctx, l.img, charX, charY, side, side); });

      auditAspects('room', base.img, roomLoaded);

      return { canvas: out.canvas, width: w, height: h };
    });
  }

  function encodeRoomBlob(room) {
    var w = room.width;
    var h = room.height;
    return canvasToBlob(room.canvas, 'image/jpeg', EXPORT_QUALITY).then(function (blob) {
      if (blob.type !== 'image/jpeg') {
        console.warn('[uncomfy-export] asked for JPG and got ' + blob.type + '. The file is ' +
          'named from its actual type so it is not mislabelled, but this browser is not doing ' +
          'what the spec says.');
      }
      return { blob: blob, width: w, height: h };
    });
  }

  function describeExport(name, result) {
    if (!result) return { output: name, dimensions: '—', type: 'failed', bytes: 0, size: '—' };
    return {
      output: name,
      dimensions: result.width + '×' + result.height,
      type: result.blob.type,
      bytes: result.blob.size,
      size: (result.blob.size / 1024).toFixed(0) + ' KB'
    };
  }

  function exportOrNull(promise, label) {
    return promise.catch(function (err) {
      console.error('[uncomfy-export] ' + label + ' export failed', err);
      return null;
    });
  }

  function uncomfyExport() {
    return Promise.all([
      exportOrNull(exportCharacter(), 'character'),
      exportOrNull(exportKeepsake(), 'keepsake')
    ]).then(function (results) {
      var keepsakeLabel = 'B · keepsake';
      if (results[1] && !results[1].framed) keepsakeLabel = 'B · keepsake (unframed fallback)';
      console.table([
        describeExport('A · character', results[0]),
        describeExport(keepsakeLabel, results[1])
      ]);
      return { character: results[0], keepsake: results[1] };
    });
  }

  var KEEPSAKE_FRAME = {
    outputWidth: 1200,
    outputHeight: 1600,

    windowCenterX: 49.46,
    windowCenterY: 43.56,
    windowWidth: 73.08,
    windowHeight: 72.88,
    windowRotation: 0,
    windowBleed: 2.5,
    nudge: 0,

    captionLeft: 12.92,
    captionTop: 80.00,
    captionWidth: 73.08,
    captionHeight: 15.50,
    captionRotation: 0,
    captionBaseline: 50,
    captionMaxHeight: 52,
    captionMaxWidth: 96,
    captionMinSize: 24
  };

  var KEEPSAKE_ELLIPSIS = '…';

  function degToRad(deg) {
    return deg * Math.PI / 180;
  }

  function keepsakeCropOffset(stage) {
    var K = KEEPSAKE_FRAME;
    var windowPxW = K.windowWidth / 100 * K.outputWidth;
    var windowPxH = K.windowHeight / 100 * K.outputHeight;
    var visible = Math.min(1, windowPxH / (windowPxW * ROOM_HEIGHT_OVER_WIDTH)) * 100;
    if (visible >= 100) return 0;

    var scale = readStagePercent(stage, '--uw-room-char-scale', ROOM_CHAR_SCALE_FALLBACK);
    var floor = readStagePercent(stage, '--uw-room-char-floor', ROOM_CHAR_FLOOR_FALLBACK);
    var offset = (floor - scale / 2) - visible / 2 + K.nudge;
    return Math.min(Math.max(offset, 0), 100 - visible);
  }

  function keepsakeCaptionStyle() {
    var root = getRoot();
    var el = root ? root.querySelector('[data-uw-postcard-caption]') : null;
    if (el) {
      var cs = window.getComputedStyle(el);
      return { family: cs.fontFamily, weight: cs.fontWeight || '400', color: cs.color };
    }
    var rootStyle = window.getComputedStyle(document.documentElement);
    console.warn('[uncomfy-keepsake] no caption element to read type from — falling back to ' +
      'the root tokens.');
    return {
      family: rootStyle.getPropertyValue('--uw-font-heading').trim() || 'sans-serif',
      weight: '400',
      color: rootStyle.getPropertyValue('--uw-text').trim() || 'currentColor'
    };
  }

  function firstFontFamily(list) {
    return String(list || '').split(',')[0].trim().replace(/^["']|["']$/g, '');
  }

  function keepsakeLoadCaptionFont(type, size) {
    if (!document.fonts || !document.fonts.load) {
      console.warn('[uncomfy-keepsake] no CSS Font Loading API — the caption will use ' +
        'whatever face is resolved at draw time.');
      return Promise.resolve();
    }
    var family = firstFontFamily(type.family);
    var spec = type.weight + ' ' + Math.ceil(size) + 'px "' + family + '"';
    return document.fonts.load(spec).then(function (faces) {
      if (!faces || !faces.length) {
        console.error('[uncomfy-keepsake] "' + family + '" matched no loaded font face (' +
          spec + '). The caption will be drawn in a FALLBACK font. Downloading anyway.');
      }
    }).catch(function (err) {
      console.error('[uncomfy-keepsake] could not load "' + family + '" (' + spec + '). ' +
        'The caption will be drawn in a FALLBACK font. Downloading anyway.', err);
    });
  }

  function keepsakeFitCaption(ctx, text, type, boxW, boxH) {
    var K = KEEPSAKE_FRAME;
    var maxWidth = K.captionMaxWidth / 100 * boxW;
    var size = K.captionMaxHeight / 100 * boxH;

    function setSize(px) {
      ctx.font = type.weight + ' ' + px + 'px ' + type.family;
    }

    setSize(size);
    while (ctx.measureText(text).width > maxWidth && size > K.captionMinSize) {
      size = Math.max(K.captionMinSize, size - 1);
      setSize(size);
    }
    if (ctx.measureText(text).width <= maxWidth) return { text: text, size: size };

    var cut = text.length;
    while (cut > 0) {
      cut--;
      var candidate = text.slice(0, cut).replace(/\s+$/, '') + KEEPSAKE_ELLIPSIS;
      if (ctx.measureText(candidate).width <= maxWidth) return { text: candidate, size: size };
    }
    console.warn('[uncomfy-keepsake] the caption strip is too narrow for even an ellipsis at ' +
      K.captionMinSize + 'px — drawing the frame with no caption.');
    return null;
  }

  function keepsakeComposite(room, frameImg, stage, type, name) {
    var K = KEEPSAKE_FRAME;
    var w = K.outputWidth;
    var h = K.outputHeight;
    var out = makeExportCanvas(w, h);
    var ctx = out.ctx;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    if (frameImg.naturalWidth !== w || frameImg.naturalHeight !== h) {
      console.warn('[uncomfy-keepsake] frame art is ' + frameImg.naturalWidth + '×' +
        frameImg.naturalHeight + ' but KEEPSAKE_FRAME says ' + w + '×' + h + '. The rects are ' +
        'percentages so the composition still lands, but the measurements were taken against ' +
        'the constant.');
    }

    var winW = (K.windowWidth + K.windowBleed * 2) / 100 * w;
    var winH = (K.windowHeight + K.windowBleed * 3 / 4 * 2) / 100 * h;
    var roomW = winW;
    var roomH = winW * ROOM_HEIGHT_OVER_WIDTH;
    var roomY = -keepsakeCropOffset(stage) / 100 * roomH;

    ctx.save();
    ctx.translate(K.windowCenterX / 100 * w, K.windowCenterY / 100 * h);
    ctx.rotate(degToRad(K.windowRotation));
    ctx.beginPath();
    ctx.rect(-winW / 2, -winH / 2, winW, winH);
    ctx.clip();
    drawContain(ctx, room.canvas, -winW / 2, -winH / 2 + roomY, roomW, roomH);
    ctx.restore();

    drawContain(ctx, frameImg, 0, 0, w, h);

    var text = String(name || '').trim();
    if (!text) return { canvas: out.canvas, width: w, height: h };

    var boxW = K.captionWidth / 100 * w;
    var boxH = K.captionHeight / 100 * h;
    var fitted = keepsakeFitCaption(ctx, text, type, boxW, boxH);
    if (!fitted) return { canvas: out.canvas, width: w, height: h };

    ctx.save();
    ctx.translate((K.captionLeft + K.captionWidth / 2) / 100 * w,
                  (K.captionTop + K.captionHeight / 2) / 100 * h);
    ctx.rotate(degToRad(K.captionRotation));
    ctx.font = type.weight + ' ' + fitted.size + 'px ' + type.family;
    ctx.fillStyle = type.color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(fitted.text, 0, (K.captionBaseline / 100 - 0.5) * boxH);
    ctx.restore();

    return { canvas: out.canvas, width: w, height: h };
  }

  function exportKeepsake() {
    var root = getRoot();
    var stage = root ? root.querySelector('[data-uw-room-stage]') : null;
    var card = root ? root.querySelector('[data-uw-postcard]') : null;
    var frameUrl = card ? card.getAttribute('data-uw-keepsake-frame-export') : null;

    return buildRoomCanvas().then(function (room) {
      return Promise.resolve().then(function () {
        if (!stage || !frameUrl) {
          throw new Error('[uncomfy-keepsake] no polaroid frame image is set (section ' +
            'setting "Keepsake frame")');
        }
        return loadExportImage(frameUrl).then(function (frameImg) {
          var type = keepsakeCaptionStyle();
          var probe = KEEPSAKE_FRAME.captionMaxHeight / 100 *
            (KEEPSAKE_FRAME.captionHeight / 100 * KEEPSAKE_FRAME.outputHeight);
          return keepsakeLoadCaptionFont(type, probe).then(function () {
            var framed = keepsakeComposite(room, frameImg, stage, type, state.name);
            return canvasToBlob(framed.canvas, 'image/png').then(function (blob) {
              return { blob: blob, width: framed.width, height: framed.height, framed: true };
            });
          });
        });
      }).catch(function (err) {
        console.error('[uncomfy-keepsake] could not build the framed keepsake — falling back ' +
          'to the unframed room download.', err);
        return encodeRoomBlob(room).then(function (result) {
          result.framed = false;
          return result;
        });
      });
    });
  }

  function uncomfyExportKeepsake() {
    return exportKeepsake().then(function (result) {
      var label = result.framed ? 'C · keepsake' : 'C · keepsake (unframed fallback)';
      console.table([describeExport(label, result)]);
      return result;
    });
  }

  var CART_FILE_LIMIT = 20 * 1024 * 1024;

  var EXPORT_EXTENSIONS = {
    'image/png': 'png',
    'image/webp': 'webp',
    'image/jpeg': 'jpg'
  };

  function exportFileName(blob, kind) {
    var parts = ['uncomfy'];
    if (state.name) {
      parts.push(state.name);
    } else {
      if (state.friend) parts.push(state.friend.name);
      if (state.fur) parts.push(state.fur.fur);
    }
    if (kind) parts.push(kind);
    var base = parts.join('-').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    return base + '.' + (EXPORT_EXTENSIONS[blob.type] || 'bin');
  }

  function attachFile(input, blob, kind) {
    var file = new File([blob], exportFileName(blob, kind), { type: blob.type });
    var dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;
    if (file.size > CART_FILE_LIMIT) {
      console.warn('[uncomfy-cart] ' + file.name + ' is ' + (file.size / 1048576).toFixed(1) +
        ' MB, past Shopify\'s 20 MB file ceiling — expect this upload to be rejected.');
    }
    return file;
  }

  function firstLineItem(data) {
    if (!data) return null;
    if (Array.isArray(data.items)) return data.items[0] || null;
    return data;
  }

  function classifyProperty(value) {
    if (value == null || value === '') return 'MISSING — no value came back';
    if (/^(https?:)?\/\/[^/]*cdn\.shopify\.com\//.test(String(value))) return 'CDN URL ✓';
    if (/^(https?:)?\/\//.test(String(value))) return 'a URL, but not cdn.shopify.com';
    return 'NOT a URL — the file was not uploaded';
  }

  var FILE_PROPERTIES = ['_polaroid_url', '_character_url'];

  function reportLineItem(label, item) {
    var props = (item && item.properties) || {};
    var keys = Object.keys(props);
    FILE_PROPERTIES.forEach(function (key) {
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    console.log('[uncomfy-cart] ' + label);
    console.table(keys.map(function (key) {
      var isFile = FILE_PROPERTIES.indexOf(key) !== -1;
      return {
        property: key,
        kind: isFile ? 'file (hidden)' : 'visible',
        verdict: isFile ? classifyProperty(props[key]) : (props[key] ? 'set' : 'MISSING'),
        value: props[key] || '—'
      };
    }));
    return props;
  }

  function accessoryLabel(acc) {
    var base = acc.base_name || acc.name;
    if (acc.color) return base + ' - ' + acc.color;
    return base;
  }

  function selectedAccessoryLabels() {
    return currentAccessories
      .filter(function (acc) { return isAccSelected(acc.name); })
      .map(accessoryLabel);
  }

  function appendVisibleProperties(formData) {
    var props = [];
    if (state.name) props.push(['Character Name', state.name]);
    if (state.friend) props.push(['Friend', state.friend.name]);
    if (state.fur) props.push(['Fur Color', state.fur.fur]);
    var accessories = selectedAccessoryLabels();
    if (accessories.length) props.push(['Accessories', accessories.join(', ')]);

    if (termsRequired() && termsAccepted()) {
      props.push(['Made-to-order acknowledged', termsLabel()]);
    }
    props.forEach(function (pair) {
      formData.append('properties[' + pair[0] + ']', pair[1]);
    });
    return props;
  }

  function pluralAccessories(count) {
    return count + ' ' + (count === 1 ? 'accessory' : 'accessories');
  }

  function findVariantForCount(count) {
    for (var i = 0; i < currentCartVariants.length; i++) {
      if (String(currentCartVariants[i].count).trim() === String(count)) {
        return currentCartVariants[i];
      }
    }
    return null;
  }

  function variantIdForSelection() {
    var count = state.accessories.length;

    if (!state.path) {
      throw new Error('[uncomfy-cart] no path chosen — nothing to buy. This should be ' +
        'unreachable: the Friend step is gated on a path.');
    }

    if (pricingMode() === 'none') {
      throw new Error('[uncomfy-cart] the "' + state.path + '" path does not sell anything. ' +
        'Refusing to add rather than guess a product.');
    }

    if (count < ACC_MIN) {
      throw new Error('[uncomfy-cart] ' + pluralAccessories(count) + ' — at least ' +
        ACC_MIN + ' is required. Refusing to add a build that cannot be made.');
    }

    if (!currentCartVariants.length) {
      throw new Error('[uncomfy-cart] no purchasable variants found for the "' + state.path +
        '" path. Check its product setting is filled in and, on a tiered path, that the ' +
        'product has an "Accessory count" option. Note: Unlisted products may not appear in ' +
        'the theme editor\'s product picker — if the picker is empty, set the handle ' +
        'directly in templates/page.builder.json.');
    }

    var match = variantForPath();

    if (!match) {
      var offered = currentCartVariants.map(function (v) { return v.count; }).join(', ');
      throw new Error('[uncomfy-cart] no variant with "Accessory count" = ' + count +
        ' on the "' + state.path + '" path (the product offers: ' + offered + '). Refusing ' +
        'to add rather than charge the wrong price.');
    }

    if (!match.available) {
      throw new Error('[uncomfy-cart] the variant for ' + pluralAccessories(count) +
        ' is out of stock.');
    }

    return { count: count, variantId: String(match.id) };
  }

  function uncomfyAddToCart() {
    var root = getRoot();
    var form = root ? root.querySelector('[data-uw-cart-form]') : null;
    if (!form) return Promise.reject(new Error('[uncomfy-cart] cart form not found'));

    var imageInput = form.querySelector('[data-uw-file-image]');
    var stickerInput = form.querySelector('[data-uw-file-sticker]');
    var variantInput = form.querySelector('[data-uw-variant-input]');
    if (!imageInput || !stickerInput) {
      return Promise.reject(new Error('[uncomfy-cart] file inputs not found on the cart form'));
    }
    if (!variantInput) {
      return Promise.reject(new Error('[uncomfy-cart] variant input not found on the cart form'));
    }

    var selection;
    try {
      variantIdForSelection();
    } catch (err) {
      return Promise.reject(err);
    }

    return uncomfyExport().then(function (out) {
      if (!out.keepsake || !out.character) {
        throw new Error('[uncomfy-cart] both exports must succeed before adding to cart');
      }

      attachFile(imageInput, out.keepsake.blob, out.keepsake.framed ? 'keepsake' : 'room-fallback');
      attachFile(stickerInput, out.character.blob, 'sticker');

      selection = variantIdForSelection();
      variantInput.value = selection.variantId;

      var formData = new FormData(form);
      var visible = appendVisibleProperties(formData);
      console.log('[uncomfy-cart] ' + selection.count + ' ' +
        (selection.count === 1 ? 'accessory' : 'accessories') + ' → variant ' + selection.variantId);
      console.table(visible.map(function (pair) {
        return { property: pair[0], value: pair[1] };
      }));

      return fetch(form.getAttribute('action') + '.js', { method: 'POST', body: formData });
    }).then(function (res) {
      return res.json().then(function (data) { return { res: res, data: data }; });
    }).then(function (r) {
      console.log('[uncomfy-cart] POST ' + form.getAttribute('action') + '.js → ' + r.res.status);
      if (!r.res.ok) {
        console.error('[uncomfy-cart] add failed', r.data);
        return { ok: false, status: r.res.status, response: r.data };
      }

      var item = firstLineItem(r.data);
      var added = reportLineItem('as returned by /cart/add.js', item);

      var cartUrl = (form.getAttribute('data-uw-cart-url') || '/cart') + '.js';
      return fetch(cartUrl).then(function (cartRes) { return cartRes.json(); })
        .then(function (cart) {
          var line = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === (item && item.key)) { line = cart.items[i]; break; }
          }
          var stored = line ? reportLineItem('as stored in /cart.js', line) : {};
          var bothSurvived = classifyProperty(stored._polaroid_url) === 'CDN URL ✓' &&
            classifyProperty(stored._character_url) === 'CDN URL ✓';
          console.log('[uncomfy-cart] both file properties survived on one line item: ' +
            (bothSurvived ? 'YES' : 'NO'));
          return {
            ok: true,
            status: r.res.status,
            accessoryCount: selection.count,
            variantId: selection.variantId,
            bothSurvived: bothSurvived,
            added: added,
            stored: stored,
            item: line || item
          };
        });
    });
  }

  var BUY_IDLE_LABEL = 'add to basket';
  var BUY_BUSY_LABEL = 'wrapping them up…';

  var buyBusy = false;

  var postcardView = 'actions';

  function showPostcardView(view) {
    postcardView = view;
    refreshPostcardViews();
  }

  function fillName(template, neutral) {
    return String(template || '').split('{name}').join(state.name || neutral);
  }

  function renderNameTemplate(selector, neutral) {
    var root = getRoot();
    if (!root) return;
    var el = root.querySelector(selector);
    if (!el) return;
    el.textContent = fillName(el.getAttribute('data-uw-template'), neutral);
  }

  function fillCharacterThumb(gallery) {
    var slot = gallery.querySelector('[data-uw-gallery-friend]');
    if (!slot) return;
    slot.textContent = '';
    characterLayerUrls().forEach(function (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      slot.appendChild(img);
    });
  }

  function resetDetailsGallery(gallery, stage) {
    if (stage) stage.setAttribute('data-uw-main', 'postcard');
    gallery.querySelectorAll('[data-uw-gallery-thumb]').forEach(function (t, i) {
      t.classList.toggle('is-active', i === 0);
    });
    fillCharacterThumb(gallery);
  }

  function refreshDetailsGallery(view) {
    var root = getRoot();
    if (!root) return;
    var postcard = root.querySelector('[data-uw-postcard]');
    var stage = root.querySelector('[data-uw-detail-stage]');
    var onPostcardStep = !!postcard && !postcard.hidden;
    var framed = false;
    root.querySelectorAll('[data-uw-details-gallery]').forEach(function (el) {
      var showing = onPostcardStep && view === 'details' &&
        el.getAttribute('data-uw-details-gallery') === state.path;
      el.hidden = !showing;
      if (showing) framed = true;
      resetDetailsGallery(el, stage);
    });
    if (stage) {
      if (framed) stage.setAttribute('data-uw-framed', '');
      else stage.removeAttribute('data-uw-framed');
    }
  }

  function guestbookQuery() {
    var parts = ['uwv=1'];
    function add(key, value) {
      if (value) parts.push(key + '=' + value);
    }
    function atom(value) {
      return encodeURIComponent(String(value == null ? '' : value));
    }
    if (state.friend) add('f', atom(state.friend.name));
    if (state.fur) add('c', atom(state.fur.fur));
    if (state.accessories.length) {
      add('a', state.accessories.map(function (a) { return atom(a.name); }).join(','));
    }
    var rooms = [];
    for (var key in state.room) {
      if (state.room[key]) rooms.push(atom(key) + ':' + atom(state.room[key].name));
    }
    if (rooms.length) add('r', rooms.join(','));
    if (state.name) add('n', atom(state.name));
    return parts.join('&');
  }

  function refreshGuestbookLink() {
    var root = getRoot();
    if (!root) return;
    var link = root.querySelector('[data-uw-guestbook-link]');
    if (!link) return;
    var base = link.getAttribute('data-uw-guestbook-base');
    if (!base) return;
    link.setAttribute('href', base + '?' + guestbookQuery());
  }

  function refreshPostcardViews() {
    var root = getRoot();
    if (!root) return;

    var view = postcardView;
    if (view === 'details' && state.locked) view = 'actions';

    var actions = root.querySelector('[data-uw-postcard-actions]');
    var details = root.querySelector('[data-uw-postcard-details]');
    if (actions) actions.hidden = view !== 'actions';
    if (details) details.hidden = view !== 'details';

    var shareExits = root.querySelector('[data-uw-share-exits]');
    if (shareExits) shareExits.hidden = !state.locked;

    var nameField = root.querySelector('[data-uw-name-field]');
    if (nameField) nameField.hidden = state.locked;

    var cartLink = root.querySelector('[data-uw-cart-link]');
    if (cartLink) cartLink.hidden = !state.locked;

    var line = root.querySelector('[data-uw-confirm-line]');
    if (line) {
      line.hidden = !state.locked;
      line.textContent = state.name
        ? state.name + ' is in your basket'
        : 'your friend is in your basket';
    }

    root.querySelectorAll('[data-uw-details-body]').forEach(function (el) {
      el.hidden = el.getAttribute('data-uw-details-body') !== state.path;
    });

    var terms = termsNode();
    if (terms) terms.hidden = !termsRequired();
    refreshBuyEnabled();

    renderNameTemplate('[data-uw-details-heading]', 'your friend');
    renderNameTemplate('[data-uw-share-heading]', 'them');

    refreshGuestbookLink();

    refreshPrice();
    refreshTurnPage();

    try {
      refreshDetailsGallery(view);
    } catch (err) {
      console.error('[uncomfy-gallery] the details gallery failed to refresh', err);
    }
  }

  function termsNode() {
    var root = getRoot();
    return root ? root.querySelector('[data-uw-terms]') : null;
  }

  function termsRequired() {
    var root = getRoot();
    if (!root || !state.path || !termsNode()) return false;
    var list = (root.getAttribute('data-uw-terms-paths') || '').split(',');
    for (var i = 0; i < list.length; i++) {
      if (list[i].trim() === state.path) return true;
    }
    return false;
  }

  function termsAccepted() {
    var node = termsNode();
    var box = node ? node.querySelector('[data-uw-terms-check]') : null;
    return !!(box && box.checked);
  }

  function termsLabel() {
    var node = termsNode();
    var el = node ? node.querySelector('[data-uw-terms-label]') : null;
    return el ? el.textContent.trim() : '';
  }

  function refreshBuyEnabled() {
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('[data-uw-buy]');
    if (!btn) return;
    btn.disabled = buyBusy || (termsRequired() && !termsAccepted());
  }

  function setBuyError(message) {
    var root = getRoot();
    if (!root) return;
    var el = root.querySelector('[data-uw-buy-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function getLoadingPanel() {
    var root = getRoot();
    return root ? root.querySelector('[data-uw-panel="summary"]') : null;
  }

  function getLoadingCover() {
    var root = getRoot();
    return root ? root.querySelector('[data-uw-loading]') : null;
  }

  var loadingArtRequested = false;

  function preloadLoadingArt() {
    if (loadingArtRequested) return;
    var cover = getLoadingCover();
    if (!cover) return;
    loadingArtRequested = true;
    var imgs = cover.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  }

  function scheduleLoadingArtPreload() {
    if (loadingArtRequested) return;
    if (window.requestIdleCallback) window.requestIdleCallback(preloadLoadingArt);
    else window.setTimeout(preloadLoadingArt, 1200);
  }

  function setLoadingVisible(show) {
    var panel = getLoadingPanel();
    var cover = getLoadingCover();
    if (!show) {
      if (panel) panel.classList.remove('is-loading');
      if (cover) cover.hidden = true;
      return;
    }
    if (!cover || !panel) return;
    preloadLoadingArt();
    var status = cover.querySelector('[data-uw-loading-status]');
    if (status) status.textContent = BUY_BUSY_LABEL;
    cover.hidden = false;
    panel.classList.add('is-loading');

    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      cover.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  function setBuyBusy(busy) {
    setLoadingVisible(busy);
    var root = getRoot();
    if (!root) return;
    var btn = root.querySelector('[data-uw-buy]');
    if (!btn) return;
    buyBusy = busy;
    btn.textContent = busy ? BUY_BUSY_LABEL : BUY_IDLE_LABEL;
    refreshBuyEnabled();
  }

  function onBuyClick() {
    if (state.locked) return;
    setBuyError('');
    setBuyBusy(true);
    uncomfyAddToCart().then(function (result) {
      if (!result || !result.ok) {
        var detail = result && result.response ? result.response.description : null;
        setBuyError(detail || 'That didn\'t go through. Please try again.');
        setBuyBusy(false);
        return;
      }
      state.locked = true;
      setBuyBusy(false);
      refreshTabs();
      refreshBackButton();
      refreshTurnPage();
      refreshPrice();
      showPostcardView('actions');
    }).catch(function (err) {
      console.error(err);
      setBuyError('That didn\'t go through. Please try again.');
      setBuyBusy(false);
    });
  }

  function downloadBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(function () { URL.revokeObjectURL(url); }, 0);
  }

  var KEEPSAKE_WARM_DELAY = 500;

  var shareSupported = (function () {
    try {
      if (!navigator.canShare) return false;
      var probe = new File([new Uint8Array(1)], 'probe.png', { type: 'image/png' });
      return navigator.canShare({ files: [probe] }) &&
        window.matchMedia('(pointer: coarse)').matches;
    } catch (err) {
      return false;
    }
  })();

  var keepsakeCache = null;
  var keepsakeWarming = false;
  var keepsakeWarmTimer = null;

  function keepsakeSignature() {
    function ids(list) {
      return list.map(function (rec) {
        return (rec.exportUrl || rec.url) + '@' + (rec.z == null ? '' : rec.z);
      }).join('|');
    }
    return ids(characterLayers()) + '#' + ids(roomLayers()) + '#' + (state.name || '');
  }

  function warmKeepsake() {
    if (!shareSupported) return;
    if (keepsakeWarming) return;
    if (buyBusy) return;
    var sig = keepsakeSignature();
    if (keepsakeCache && keepsakeCache.sig === sig) return;
    keepsakeWarming = true;
    exportKeepsake().then(function (out) {
      if (keepsakeSignature() === sig) keepsakeCache = { sig: sig, out: out };
    }).catch(function (err) {
      console.error('[uncomfy-share] keepsake warm-up failed', err);
    }).then(function () {
      keepsakeWarming = false;
    });
  }

  function scheduleKeepsakeWarm() {
    if (!shareSupported) return;
    if (keepsakeWarmTimer) clearTimeout(keepsakeWarmTimer);
    keepsakeWarmTimer = setTimeout(function () {
      keepsakeWarmTimer = null;
      warmKeepsake();
    }, KEEPSAKE_WARM_DELAY);
  }

  function keepsakeFile(out) {
    return new File([out.blob], exportFileName(out.blob), { type: out.blob.type });
  }

  function shareKeepsake(btn) {
    var sig = keepsakeSignature();
    var warm = (keepsakeCache && keepsakeCache.sig === sig) ? keepsakeCache.out : null;

    if (btn) btn.disabled = true;
    var ready = warm ? Promise.resolve(warm) : uncomfyExportKeepsake();

    ready.then(function (out) {
      if (!out) return;
      if (warm) console.table([describeExport('C · keepsake (shared)', out)]);
      return navigator.share({ files: [keepsakeFile(out)] }).then(function () {
        sparkle(btn);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.error('[uncomfy-share] the share sheet did not take the file', err);
        downloadBlob(out.blob, exportFileName(out.blob));
        sparkle(btn);
      });
    }).catch(function (err) {
      console.error(err);
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  }

  function onSaveClick(btn) {
    if (!btn) {
      var root = getRoot();
      btn = root ? root.querySelector('[data-uw-save]') : null;
    }
    if (shareSupported) {
      shareKeepsake(btn);
      return;
    }
    if (btn) btn.disabled = true;
    uncomfyExportKeepsake().then(function (out) {
      if (out) {
        downloadBlob(out.blob, exportFileName(out.blob));
        sparkle(btn);
      }
    }).catch(function (err) {
      console.error(err);
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  }

  function onDocClick(e) {
    var root = getRoot();
    if (!root) return;

    var tab = e.target.closest('[data-uw-tab]');
    if (tab && root.contains(tab)) {
      goToStep(tab.getAttribute('data-uw-tab'));
      return;
    }

    var back = e.target.closest('[data-uw-back-page]');
    if (back && root.contains(back)) {
      var active = root.querySelector('[data-uw-tab].is-active');
      var current = active ? active.getAttribute('data-uw-tab') : TAB_ORDER[0];
      if (current === 'summary' && postcardView === 'details') {
        showPostcardView('actions');
        return;
      }
      var curIdx = TAB_ORDER.indexOf(current);
      if (curIdx > 0) goToStep(TAB_ORDER[curIdx - 1]);
      return;
    }

    var turn = e.target.closest('[data-uw-turn-page]');
    if (turn && root.contains(turn)) {
      var next = nextEnabledStep();
      if (next) {
        var box = turn.getBoundingClientRect();
        var burstX = box.left + box.width / 2;
        var burstY = box.top + box.height / 2;
        activateTab(next);
        sparkleAt(burstX, burstY);
      }
      return;
    }

    var pathCard = e.target.closest('[data-uw-path]');
    if (pathCard && root.contains(pathCard)) {
      if (isPathAvailable(pathCard)) selectPath(pathCard.getAttribute('data-uw-path'));
      return;
    }

    var friendCard = e.target.closest('[data-uw-friend-name]');
    if (friendCard && root.contains(friendCard)) {
      selectFriend(friendCard.getAttribute('data-uw-friend-name'));
      return;
    }

    var furCard = e.target.closest('[data-uw-fur-name]');
    if (furCard && root.contains(furCard)) {
      selectFur(furCard.getAttribute('data-uw-fur-name'));
      return;
    }

    var accCard = e.target.closest('[data-uw-acc-name]');
    if (accCard && root.contains(accCard)) {
      toggleAccessory(accCard.getAttribute('data-uw-acc-name'));
      return;
    }

    var roomCard = e.target.closest('[data-uw-room-name]');
    if (roomCard && root.contains(roomCard)) {
      selectRoomOption(roomCard.getAttribute('data-uw-room-name'));
      return;
    }

    var buy = e.target.closest('[data-uw-buy]');
    if (buy && root.contains(buy)) {
      onBuyClick();
      return;
    }

    var galleryThumb = e.target.closest('[data-uw-gallery-thumb]');
    if (galleryThumb && root.contains(galleryThumb)) {
      var gallery = galleryThumb.closest('[data-uw-details-gallery]');
      var stage = root.querySelector('[data-uw-detail-stage]');
      if (gallery && stage) {
        var wanted = galleryThumb.getAttribute('data-uw-gallery-thumb');
        if (wanted === 'postcard') {
          stage.setAttribute('data-uw-main', 'postcard');
        } else {
          var photo = stage.querySelector('[data-uw-detail-photo]');
          if (photo) {
            photo.src = wanted;
            photo.alt = galleryThumb.getAttribute('data-uw-gallery-alt') || '';
            var gw = galleryThumb.getAttribute('data-uw-gallery-w');
            var gh = galleryThumb.getAttribute('data-uw-gallery-h');
            if (gw) photo.setAttribute('width', gw);
            if (gh) photo.setAttribute('height', gh);
            photo.hidden = false;
            stage.setAttribute('data-uw-main', galleryThumb.getAttribute('data-uw-gallery-index') || '0');
          }
        }
        gallery.querySelectorAll('[data-uw-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === galleryThumb);
        });
      }
      return;
    }

    var save = e.target.closest('[data-uw-save]');
    if (save && root.contains(save)) {
      onSaveClick(save);
      return;
    }

    var showDetails = e.target.closest('[data-uw-show-details]');
    if (showDetails && root.contains(showDetails)) {
      showPostcardView('details');
      return;
    }

    var editFriend = e.target.closest('[data-uw-edit-friend]');
    if (editFriend && root.contains(editFriend)) {
      showPostcardView('actions');
      activateTab(editFriend.getAttribute('data-uw-edit-step') || 'accessories');
      renderPreview();
      return;
    }

    var another = e.target.closest('[data-uw-build-another]');
    if (another && root.contains(another)) {
      resetBuilder();
    }
  }

  function onDocInput(e) {
    var root = getRoot();
    if (!root) return;

    var terms = e.target.closest('[data-uw-terms-check]');
    if (terms && root.contains(terms)) {
      refreshBuyEnabled();
      return;
    }

    var input = e.target.closest('[data-uw-name-input]');
    if (!input || !root.contains(input)) return;
    state.name = input.value;
    renderPostcardCaption();
    refreshPostcardViews();
    scheduleKeepsakeWarm();
  }

  function onDocKeydown(e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var root = getRoot();
    if (!root) return;
    var current = e.target.closest('[data-uw-tab]');
    if (!current || !root.contains(current)) return;

    var tabs = Array.prototype.slice
      .call(root.querySelectorAll('[data-uw-tab]'))
      .filter(function (tab) { return isTabEnabled(tab.getAttribute('data-uw-tab')); });
    var idx = tabs.indexOf(current);
    if (idx === -1) return;

    var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
    if (next < 0) next = tabs.length - 1;
    if (next >= tabs.length) next = 0;

    var target = tabs[next];
    goToStep(target.getAttribute('data-uw-tab'));
    target.focus();
    e.preventDefault();
  }

  function run() {
    var root = getRoot();
    if (!root) {
      console.warn('[uncomfy-builder] #' + ROOT_ID + ' not found; skipping.');
      return;
    }

    var catalogs = collectCatalogs();

    currentFriends = catalogs.friends || [];
    currentFur = catalogs.fur || [];
    currentAccessories = catalogs.accessories || [];
    currentAccessoryCategories = catalogs.accessory_categories || [];
    currentRoom = catalogs.room || [];
    currentRoomCategories = catalogs.room_categories || [];

    frontispieceTemplate = null;
    currentScene = null;
    currentSceneKey = null;

    var accHintEl = root.querySelector('[data-uw-acc-hint]');
    if (accHintEl) {
      var accMax = parseInt(accHintEl.getAttribute('data-uw-acc-max'), 10);
      if (accMax > 0) ACC_MAX = accMax;
    }

    numberSteps();
    resetBuilder();
    applyPathFromUrl();
    watchScrollCues();
  }

  function applyPathFromUrl() {
    var root = getRoot();
    if (!root) return;
    var key = (new URLSearchParams(window.location.search).get('path') || '').toLowerCase();
    if (!PATH_PRICING[key]) return;
    var card = root.querySelector('[data-uw-path="' + key + '"]');
    if (!isPathAvailable(card)) return;
    selectPath(key);
    if (state.path) activateTab('friend');
  }

  function resetBuilder() {
    var root = getRoot();
    if (!root) return;

    state = { path: null, friend: null, fur: null, accessories: [], room: {}, name: '', locked: false };
    postcardView = 'actions';
    currentCartVariants = [];

    var nameInput = root.querySelector('[data-uw-name-input]');
    if (nameInput) nameInput.value = '';
    var termsBox = root.querySelector('[data-uw-terms-check]');
    if (termsBox) termsBox.checked = false;
    setBuyError('');
    setBuyBusy(false);

    markPathSelected(null);
    renderFriendGrid(currentFriends);
    renderFurGrid();
    renderAccGrid();
    renderAccHint();
    renderRoomGrid();
    renderPostcardCaption();
    refreshPostcardViews();
    refreshTabs();
    activateTab(TAB_ORDER[0]);
    refreshPrice();
    renderPreview();
    autoSelectSinglePath();
  }

  if (!window.__uncomfyBuilderInit) {
    window.__uncomfyBuilderInit = true;
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onDocKeydown);
    document.addEventListener('input', onDocInput);
    window.addEventListener('resize', syncScrollCues, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncScrollCues);
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', run);
      document.addEventListener('shopify:section:unload', run);
    }
  }

  ready(run);
})();
